<template>
  <v-list>
    <v-list-item
      v-for="(item, i) in fornecedorEnvio.contatosWhatsapp"
      :key="i"
      :value="item.id"
      color="primary">
      <v-list-item-icon >
        <v-icon :color="iconColor(item)">
          {{ icon(item) }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          {{ formatWhats(item.telefone) | naoInformado }}
        </v-list-item-title>
        <v-list-item-subtitle class="text--primary" v-if="item.nome">
          {{item.nome}}
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="!item.ativo">
          Esse número de WhatsApp está bloqueado para recebimento de mensagens.
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action v-if="hasRoleComprador">
        <v-btn icon small @click="remove(item)">
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="!fornecedorEnvio.contatosWhatsapp.length">
      <v-list-item-title class="texto">
        Nenhum telefone encontrado
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
import Vue from 'vue';
import GestaoFornecedorService from '@/modules/gestao-fornecedor/gestao-fornecedor-service';

export default {
  props: {
    hasRoleComprador: Boolean,
    fornecedor: Object,
    isNacional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fornecedorEnvio: {
        contatosWhatsapp: [],
      },
    };
  },
  computed: {
    iconColor() {
      return (contato) => {
        if (!contato.whatsappValido) {
          return '';
        }
        return contato.ativo ? 'green' : 'red';
      };
    },
    icon() {
      return contato => (contato.whatsappValido ? 'mdi-whatsapp' : 'mdi-phone');
    },
    formatWhats() {
      return whatsapp => (this.isNacional ? Vue.filter('phone')(whatsapp) : whatsapp);
    },
  },
  methods: {
    remove(item) {
      const fornecedor = { ...this.fornecedorEnvio };
      fornecedor.contatosWhatsapp = fornecedor.contatosWhatsapp.filter(
        whats => whats.id !== item.id,
      );
      this.save(fornecedor);
    },
    save(fornecedor) {
      GestaoFornecedorService.updateWhatsapp(this.fornecedor.id, fornecedor)
        .then(() => {
          this.$toast('Whatsapp removido', { color: 'success' });
          this.getWhatsapps();
        });
    },
    getWhatsapps() {
      GestaoFornecedorService.get(this.fornecedor.id)
        .then((response) => {
          const fornecedor = response.data;
          this.fornecedorEnvio.contatosWhatsapp = fornecedor.contatosWhatsapp || [];
        });
    },
  },
  created() {
    this.getWhatsapps();
  },
};
</script>
<style scoped>
.texto {
  font-size: 0.9rem;
}
</style>
